import { getValueFromPath } from './get-value-from-path';
/**
 * Parse an attribute
 * @param returnValue Object to put the parsed value into
 * @param attr The form mapping attribute to parse
 * @param o The object to read from
 */
export function deserializeProperty(returnValue, attr, o) {
    var deserializedValue;
    if (attr.deserializer !== undefined) {
        deserializedValue = attr.deserializer(o);
    }
    else {
        deserializedValue = getValueFromPath(attr.selector.split('.'), o);
    }
    if (deserializedValue === undefined && attr.defaultValue !== undefined) {
        deserializedValue = attr.defaultValue;
    }
    returnValue[attr.name] = deserializedValue;
}
//# sourceMappingURL=deserialize-property.js.map